import React from "react";

export default function CoachInfo({ selectedCoach }) {
  return (
    <div className="flex flex-col md:flex-row text-xl uppercase flex-1">
      <div className="my-auto">
        <img
          alt={`${selectedCoach.firstName} ${selectedCoach.lastName}`}
          src={selectedCoach.profilePicture || "/default-profile-img.png"}
          className="grow-0 shrink-0 rounded-md w-24 h-24"
        />
      </div>
      <div className="ml-4 flex-1">
        <p className="text-lg">
          {selectedCoach.name} {selectedCoach.lastname}
        </p>
        <p className="text-sm text-gray-700">
          {selectedCoach.university || "No university listed."}
        </p>
      </div>
    </div>
  );
}
